import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import { Button } from "../Button/index.js";
import { Palette } from "../constants.js";
import { Typography } from "../Typography/index.js";
import "@mui/material/Button";
import "@mui/material/Typography";
const BootstrapDialog = styled(Dialog)(({
  theme
}) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root, & .MuiDialogTitle-root": {
    margin: 0,
    padding: theme.spacing(2)
  }
}));
function AdvancedDialog({
  open,
  onClose,
  title,
  children,
  actions,
  CloseIconProps,
  CloseButtonProps,
  DialogTitleProps,
  DialogContentProps,
  DialogActionsProps,
  maxWidth = "md",
  primaryButton,
  onClickPrimaryButton,
  PrimaryButtonProps,
  secondaryButton,
  onClickSecondaryButton,
  SecondaryButtonProps,
  tertiaryButton,
  onClickTertiaryButton,
  TertiaryButtonProps,
  ActionButtonProps,
  helperText,
  helperTextProps = {
    variant: "caption",
    color: Palette.GRAY
  },
  ...props
}) {
  const actionProps = useMemo(() => {
    if (helperText) {
      if (actions || primaryButton || secondaryButton || tertiaryButton) {
        return {
          ...DialogActionsProps,
          sx: {
            ...DialogActionsProps == null ? void 0 : DialogActionsProps.sx,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
          }
        };
      }
      return {
        ...DialogActionsProps,
        sx: {
          ...DialogActionsProps == null ? void 0 : DialogActionsProps.sx,
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center"
        }
      };
    }
    return DialogActionsProps;
  }, [helperText, actions, primaryButton, onClickPrimaryButton, secondaryButton, onClickSecondaryButton, tertiaryButton, onClickTertiaryButton]);
  const renderedActions = useMemo(() => {
    if (actions) {
      return /* @__PURE__ */ jsxs(DialogActions, { ...actionProps, children: [
        helperText && /* @__PURE__ */ jsx(Typography, { ...helperTextProps, children: helperText }),
        actions
      ] });
    }
    if (!primaryButton && !secondaryButton && !tertiaryButton) {
      return null;
    }
    return /* @__PURE__ */ jsxs(DialogActions, { ...actionProps, children: [
      helperText && /* @__PURE__ */ jsx(Typography, { ...helperTextProps, children: helperText }),
      /* @__PURE__ */ jsxs(Box, { display: "flex", flexDirection: "row", columnGap: 1, children: [
        primaryButton && /* @__PURE__ */ jsx(Button, { variant: "Primary", size: "medium", onClick: onClickPrimaryButton, sx: {
          width: "unset"
        }, ...ActionButtonProps, ...PrimaryButtonProps, children: primaryButton }),
        secondaryButton && /* @__PURE__ */ jsx(Button, { variant: "Secondary", size: "medium", onClick: onClickSecondaryButton, sx: {
          width: "unset"
        }, ...ActionButtonProps, ...SecondaryButtonProps, children: secondaryButton }),
        tertiaryButton && /* @__PURE__ */ jsx(Button, { variant: "Tertiary", size: "medium", onClick: onClickTertiaryButton, sx: {
          width: "unset"
        }, ...ActionButtonProps, ...TertiaryButtonProps, children: tertiaryButton })
      ] })
    ] });
  }, [actionProps, helperText, actions, primaryButton, onClickPrimaryButton, secondaryButton, onClickSecondaryButton, tertiaryButton, onClickTertiaryButton]);
  const renderedBody = useMemo(() => {
    if (!children) {
      return null;
    }
    return /* @__PURE__ */ jsx(DialogContent, { dividers: true, ...DialogContentProps, children });
  }, [children, DialogContentProps]);
  return /* @__PURE__ */ jsxs(BootstrapDialog, { open, onClose, maxWidth, sx: {
    ".MuiDialog-paper": {
      width: "100%",
      padding: "unset"
    }
  }, ...props, children: [
    /* @__PURE__ */ jsx(DialogTitle, { ...DialogTitleProps, children: title }),
    /* @__PURE__ */ jsx(IconButton, { "aria-label": "close", onClick: onClose, sx: {
      position: "absolute",
      right: 8,
      top: 8,
      color: (theme) => theme.palette.grey[500]
    }, ...CloseButtonProps, children: /* @__PURE__ */ jsx(CloseIcon, { ...CloseIconProps }) }),
    renderedBody,
    renderedActions
  ] });
}
export {
  AdvancedDialog
};
//# sourceMappingURL=index.js.map
